// src/components/ErrorBoundary.js
import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to an error reporting service in production
    if (process.env.NODE_ENV === 'production') {
      // Could integrate with error tracking service here
    }
  }

  handleReload = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <div style={styles.content}>
            <h1 style={styles.title}>Something went wrong</h1>
            <p style={styles.message}>
              We apologize for the inconvenience. Please try refreshing the page or return to the home page.
            </p>
            <div style={styles.actions}>
              <button onClick={this.handleReload} style={styles.button}>
                Return Home
              </button>
              <button onClick={() => window.location.reload()} style={styles.buttonSecondary}>
                Refresh Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0a0a0a',
    padding: '20px',
  },
  content: {
    textAlign: 'center',
    maxWidth: '500px',
  },
  title: {
    fontSize: '32px',
    color: '#e0ba6b',
    marginBottom: '16px',
    fontWeight: '700',
  },
  message: {
    fontSize: '16px',
    color: '#b0b0b0',
    lineHeight: '1.6',
    marginBottom: '32px',
  },
  actions: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  button: {
    padding: '14px 32px',
    fontSize: '16px',
    fontWeight: '600',
    backgroundColor: '#e0ba6b',
    color: '#0a0a0a',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    minWidth: '150px',
  },
  buttonSecondary: {
    padding: '14px 32px',
    fontSize: '16px',
    fontWeight: '600',
    backgroundColor: 'transparent',
    color: '#e0ba6b',
    border: '2px solid #e0ba6b',
    borderRadius: '4px',
    cursor: 'pointer',
    minWidth: '150px',
  },
};

export default ErrorBoundary;
